var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Connection, DATA_TYPE } from 'jsstore';
import workerInjector from 'jsstore/dist/worker_injector';
import NQSRequest from '../nqs/NQSRequest';
import { CoreTag, Method } from '../../common/Constants';
import Log from '../../common/log';
import Constants from '../nqs/Services';
class INQSRequest {
    constructor() {
        this.id = 0;
        this.isHttps = true;
        this.host = '';
        this.service = Constants.Service.APP_ANALYTICS_PLUGIN_LOGS;
        this.method = Method.GET;
        this.params = {};
    }
}
export default class CoreDatabase {
    constructor() {
        this.nqsRequestsTable = 'NQSRequests';
        this.nqsRequestsDatabase = {
            name: this.nqsRequestsTable,
            columns: {
                // Here "Id" is name of column
                id: {
                    primaryKey: true,
                    autoIncrement: true
                },
                isHttps: {
                    notNull: true,
                    dataType: DATA_TYPE.Boolean
                },
                host: {
                    notNull: true,
                    dataType: DATA_TYPE.String
                },
                service: {
                    notNull: true,
                    dataType: DATA_TYPE.String
                },
                params: {
                    notNull: true,
                    dataType: DATA_TYPE.Object
                },
                body: {
                    notNull: false,
                    dataType: DATA_TYPE.Object
                }
            }
        };
        this.notSupported = false;
        if (!('indexedDB' in window)) {
            Log.debug("This browser doesn't support IndexedDB");
            this.notSupported = true;
            return;
        }
        const db = {
            name: 'CoreDatabase',
            tables: [this.nqsRequestsDatabase]
        };
        this.connection = new Connection();
        this.connection.addPlugin(workerInjector);
        this.connection.initDb(db);
    }
    getSavedRequests() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.notSupported || !this.connection)
                return [];
            return (yield this.connection.select({
                from: this.nqsRequestsTable
            }))
                .filter((r) => r.host !== '')
                .map((request) => new NQSRequest(request.isHttps, request.host, request.service, request.method, request.params, request.body));
        });
    }
    cleanSavedRequests() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.notSupported)
                return;
            yield ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.clear(this.nqsRequestsTable));
        });
    }
    saveRequest(request) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.notSupported)
                return;
            try {
                yield ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.insert({
                    into: this.nqsRequestsTable,
                    values: [
                        {
                            isHttps: request.performHttps(),
                            host: request.getHost(),
                            service: request.getService(),
                            method: (_b = request.getMethod()) !== null && _b !== void 0 ? _b : Method.GET,
                            params: request.getParams(),
                            body: request.getBody()
                        }
                    ]
                }));
            }
            catch (e) {
                Log.debug(CoreTag, `Failed to save ${request.getService()} request`);
            }
        });
    }
}
